// extracted by mini-css-extract-plugin
export default {"container":"CampaignBottom_container__2LeNA"};